module.exports = __webpack_public_path__ + "d3bfafb782da466b8ff96af8cd25f3d0.png";